import {
  DATE_FORMAT_DD_MMM_YYYY,
  classnames,
  fDate,
  fDateTime,
} from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { DateTimeProps as Props } from './types';

export const DateTime = memo(
  ({ className, value, noTime, format, tooltipFormat, ...other }: Props) => {
    const dateFn = noTime || format ? fDate : fDateTime;
    // const str = String(dateFn(value, format) || '');
    const tooltipStr = String(
      dateFn(value, tooltipFormat || DATE_FORMAT_DD_MMM_YYYY) || ''
    );

    if (!value) return null;

    return (
      <Styled.Wrapper
        className={classnames('DateTime', className)}
        tooltipValue={tooltipStr}
        item={tooltipStr}
        fontWeight={400}
        {...other}
      />
    );
  }
);

DateTime.displayName = 'DateTime';
